import { NotificationContext } from './NotificationContext';
import { useEffect, useState, useContext, useMemo } from 'react';
import { fetchNotificationsService } from '../../global-services/notification.service';
import { UserContext } from '../user/UserContext';
import { SocketContext } from '../socket/SocketContext';
import { toast } from 'sonner';

export default function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useState(true);
  const [error, setError] = useState(null);
  const [refreshNotifications, setRefreshNotifications] = useState(false);
  const { loggedIn, user } = useContext(UserContext);
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoadingNotifications(true);
        const data = await fetchNotificationsService();
        setNotifications(data.notifications || []);
      } catch (err) {
        setError(err.message);
        setNotifications([]);
      } finally {
        setLoadingNotifications(false);
      }
    };

    if (loggedIn) {
      fetchNotifications();
    }
  }, [refreshNotifications, loggedIn]);

  useEffect(() => {
    if (loggedIn && socket && user?.id) {
      socket.emit('join', `user_${user.id}`);

      const handleNewNotification = (data) => {
        setNotifications((prev) => [data, ...prev]);

        toast.success(data.message, {
          duration: 6000,
        });
      };

      socket.on('new-notification', handleNewNotification);

      return () => {
        socket.off('new-notification', handleNewNotification);
      };
    }
  }, [loggedIn, socket]);

  const value = useMemo(
    () => ({
      notifications,
      loadingNotifications,
      error,
      setNotifications,
      setRefreshNotifications,
    }),
    [notifications, loadingNotifications, error, setRefreshNotifications]
  );

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}
